export default __webpack_public_path__ + "static/media/logo_Qibo-io-10.dcc546fe.svg";